import { forwardRef } from 'react';
import styled from 'styled-components';
import { theme } from './color_swatch.theme';

interface ColorSwatchProps {
	/**
	 * The color to display. Any CSS color value, most commonly a design token.
	 * @example color={tokens.color.bg.interactive}
	 */
	color: string;
}

const StyledColorSwatch = styled.span`
	display: block;
	flex-shrink: 0;
	width: ${theme.getValue('baseSize')};
	height: ${theme.getValue('baseSize')};
	border-radius: ${theme.getValue('baseBorderRadius')};
`;

/**
 * A small square of color used to visually connect content to a color-coded
 * concept. It's purely decorative and is therefore hidden from assistive
 * technologies, so the meaning of the color always has to be available as text
 * as well.
 *
 * @example
 * ```tsx
 * <ColorSwatch color={tokens.color.bg.interactive} />
 * ```
 */
const CellulaColorSwatch = forwardRef<HTMLSpanElement, ColorSwatchProps>(({ color }, ref) => {
	return <StyledColorSwatch aria-hidden='true' style={{ background: color }} ref={ref} />;
});

/* ########################################################################## */
/* ############################### PUBLIC API ############################### */
/* ########################################################################## */

export type { ColorSwatchProps };
export { CellulaColorSwatch as ColorSwatch };
